import React, { useEffect, useState } from "react";
import "./UpdateTemplateModal.scss";
import LockIcon2 from "../../../components/icons/LockIcon2";
import StandardTemplatesList from "./StandardTemplatesList";
import ProTemplatesList from "./ProTemplatesList";
import AgencyPersonalizedTemplatesList from "./AgencyPersonalizedTemplatesList";
import { useLocation, useSearchParams } from "react-router-dom";
import { PropertyApi } from "../../../utils/api/Property";

interface UpdateTemplateModalProps {
  open: boolean;
  onClose: () => void;
  selectedDesignTemplateId: string;
  isForOtherImages?: boolean;
  templateTypeId?: string;
  subscriptionType?: string;
  postType?: string;
  listingType?: string;
  onConfirm: (templateId: string, imageUrl: string) => void;
}

const UpdateTemplateModal: React.FC<UpdateTemplateModalProps> = ({
  open,
  onClose,
  selectedDesignTemplateId,
  isForOtherImages = false,
  onConfirm,
  templateTypeId: templateTypeIdProp,
  subscriptionType: subscriptionTypeProp,
  postType: postTypeProp,
  listingType: listingTypeProp,
}) => {
  const [show, setShow] = useState(open);
  const [closing, setClosing] = useState(false);
  const [state, setState] = useState({ selectedId: "1" });
  const [searchParams] = useSearchParams();

  // const subscriptionType =
  //   subscriptionTypeProp || searchParams.get("subscription_type") || "";
  // const listingType = listingTypeProp || searchParams.get("listing_type") || "";
  // const postType = postTypeProp || searchParams.get("post_type") || "";
  // const templateTypeId =
  //   templateTypeIdProp || searchParams.get("template_type") || "";

  const openHomeScheduleId = searchParams.get("open_home_schedule_id");
  const updatepostType = searchParams.get("post_type") || "";

  const handleConfirm = () => {
    onConfirm(selectedTemplate.id || "", selectedTemplate.image || "");
    onClose();
  };

  const [selectedTemplate, setSelectedTemplate] = useState({
    id: "",
    image: "",
  });

  const location = useLocation();
  const handleTemplateSelect = (id: string, imageUrl: string) => {
    setSelectedTemplate({ id, image: imageUrl });
  };

  useEffect(() => {
    if (open) {
      setShow(true);
      setClosing(false);
    } else if (show) {
      setClosing(true);
      const timeout = setTimeout(() => {
        setShow(false);
        setClosing(false);
      }, 250);
      return () => clearTimeout(timeout);
    }
  }, [open, show]);

  const onClickSelect = (id: string) => {
    setState({ ...state, selectedId: id });
  };

  const selectTemplateTab = [
    { id: "1", title: "Standard Templates" },
    { id: "2", title: "Personalized Templates" },
    { id: "3", title: "Brand Templates" },
  ];

  if (!show) return null;

  let headingText = "Update Template";
  if (isForOtherImages) {
    headingText = "Update Template for Other Images";
  } else if (location.pathname.includes("schedule-open-home")) {
    headingText = "Update Open Home Template";
  } else if (location.pathname.includes("property-post")) {
    headingText = "Update Property Post Template";
  } else if (location.pathname.includes("review-post")) {
    headingText = "Update Review Template";
  } else if (location.pathname.includes("schedule-auction")) {
    headingText = "Update Auction Template";
  }

  return (
    <div
      className={`change-modal-overlay ${closing ? "fade-out" : "fade-in"}`}
      onClick={onClose}
    >
      <div
        className={`change-modal-card ${closing ? "scale-out" : "scale-in"}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>{headingText}</h3>
        </div>

        <div className="tab-container">
          {selectTemplateTab.map((data) => (
            <button
              key={data.id}
              className={`tab-pill ${
                data.id === state.selectedId ? "active" : ""
              }`}
              onClick={() => onClickSelect(data.id)}
            >
              {data.title}
            </button>
          ))}
        </div>

        <div className="modal-body">
          {state.selectedId === "1" ? (
            <StandardTemplatesList
              selectedId={selectedDesignTemplateId}
              templateTypeIdProp={templateTypeIdProp}
              subscriptionTypeProp={subscriptionTypeProp}
              postTypeProp={postTypeProp}
              listingTypeProp={listingTypeProp}
              hideSelectedTemplate={true}
              onSelectTemplate={handleTemplateSelect}
            />
          ) : state.selectedId === "2" ? (
            <AgencyPersonalizedTemplatesList
              selectedId={selectedDesignTemplateId}
              templateTypeIdProp={templateTypeIdProp}
              subscriptionTypeProp={subscriptionTypeProp}
              postTypeProp={postTypeProp}
              listingTypeProp={listingTypeProp}
              hideSelectedTemplate={true}
              onSelectTemplate={handleTemplateSelect}
            />
          ) : (
            <ProTemplatesList
              selectedId={selectedDesignTemplateId}
              templateTypeIdProp={templateTypeIdProp}
              subscriptionTypeProp={subscriptionTypeProp}
              postTypeProp={postTypeProp}
              listingTypeProp={listingTypeProp}
              hideSelectedTemplate={true}
              onSelectTemplate={handleTemplateSelect}
            />
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-outline" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-primary"
            onClick={handleConfirm}
            disabled={!selectedTemplate.id}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateTemplateModal;
